"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgStr = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Input_1 = require("../../../../2-inline-block/Input");
const FormRow_1 = require("../../../../3-list-item/FormRow");
const css_1 = require("./css");
const ArgStrCompact_1 = require("./ArgStrCompact");
const unwrap = (v) => {
    if (v && typeof v === 'object' && 'value' in v)
        return String(v.value ?? '');
    return v ?? '';
};
const ArgStr = (props) => {
    if (props.compact)
        return React.createElement(ArgStrCompact_1.ArgStrCompact, { ...props });
    const { param, compact: _compact, onEnter, value, onChange, ...rest } = props;
    const defaultable = !!param.defaultable;
    const handleEnter = (event) => {
        onEnter?.(event);
        param.onSubmit?.();
    };
    return (React.createElement("div", { className: css_1.argBlockCss },
        React.createElement(FormRow_1.FormRow, { title: param.display?.() ?? param.name ?? param.id, optional: param.optional },
            React.createElement(Input_1.Input, { ...rest, onEnter: handleEnter, value: unwrap(value), onChange: (v) => (defaultable ? onChange({ def: false, value: v }) : onChange(v)), placeholder: param.placeholder, type: "text" }))));
};
exports.ArgStr = ArgStr;
